module.exports = __webpack_public_path__ + "c357e990bbc5c3589f6dca92d0d06f85.png";